import { ETLExecutionModeEnum, ETLJobRecurrenceEnum } from '~/api/types';

export const initialDefaults = {
  name: undefined,
  notebook_id: undefined,
  file_name: undefined,
  execution_mode: ETLExecutionModeEnum.ON_DEMAND,
  start_date: undefined,
  time: undefined,
  frequency: ETLJobRecurrenceEnum.NOT_REPEAT,
  end_date: undefined,
};
